module.exports = __webpack_public_path__ + "static/mobilenotifications-length-do-1b280f16b8de92dd17aa22e1f3c9c158.png";